import { Component, Input, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { HighlighedText } from '@generated/graphql';

@Component({
    selector: 'app-knowledge-highlighted-text',
    templateUrl: './knowledge-highlighted-text.component.html',
    imports: [FontAwesomeModule],
})
export class KnowledgeHighlightedTextComponent implements OnInit {
    @Input() entry: HighlighedText;

    faCircleInfo = faCircleInfo;
    constructor() {}

    ngOnInit(): void {}
}
